export default "/images/vendor/flag-icons/flags/4x3/kw.svg?1ac81961aeb84840db2f97db2dba5536";